import { render, staticRenderFns } from "./PricesListViewModal.vue?vue&type=template&id=7a5ff2fa&scoped=true"
import script from "./PricesListViewModal.vue?vue&type=script&lang=js"
export * from "./PricesListViewModal.vue?vue&type=script&lang=js"
import style0 from "./PricesListViewModal.vue?vue&type=style&index=0&id=7a5ff2fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5ff2fa",
  null
  
)

export default component.exports